<template>
  <div class="c-app">
    <CWrapper>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view />
            </transition>
          </CContainer>
        </main>
        <Footer />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import Footer from "../commons/Footer";

export default {
  name: "ErrorLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "株式会社 Fabbi"
    };
  },
  components: {
    Footer
  },
  computed: {
    locale: function() {
      return this.$i18n.locale;
    }
  }
};
</script>
<style scoped>
.c-main {
  background-color: #ffff;
}
</style>
